// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"d8736224","277":"eafea93c","373":"385a2e78","895":"73331a92"}[chunkId] + ".chunk.js";
};